import { BaseApiService } from './base-api.service';

// iContact API types
export interface IContactContact {
    contactId: string;
    email: string;
    firstName?: string;
    lastName?: string;
    status?: string;
    createDate?: string;
    bounceCount?: number;
}

export interface IContactSubscription {
    subscriptionId: string;
    contactId: string;
    listId: string;
    listName: string;
    status: 'normal' | 'pending' | 'unsubscribed';
    addDate?: string;
    confirmDate?: string;
}

export interface IContactFolderContactInfo {
    folderName: string;
    folderId: string;
    contact: IContactContact;
    subscriptions: IContactSubscription[];
}

export interface IContactSearchResponse {
    email: string;
    foundInFolders: number;
    contacts: IContactFolderContactInfo[];
}

export interface IContactSearchResult {
    success: boolean;
    data?: IContactSearchResponse;
    error?: string;
}

class IContactApiService extends BaseApiService {
    /**
     * Search for a contact by email across all iContact folders
     */
    async searchContact(email: string): Promise<IContactSearchResult> {
        try {
            const response = await this.client.get<IContactSearchResponse>(
                `/api/ca/icontact/contacts/${encodeURIComponent(email)}`,
            );
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Failed to search contact',
            };
        }
    }
}

export const icontactApi = new IContactApiService();
